import React from 'react';

import {
  DateTimePicker,
  DateTimePickerProps
} from '../../DateTimePicker';

import { useStyles } from './styles';

import { DateTimePickerIcon } from './DateTimePickerIcon/DateTimePickerIcon';
import { DateTimePickerArrowIcon } from './DateTimePickerArrowIcon/DateTimePickerArrowIcon';
import { DatePickerClearButton } from './DatePickerClearButton/DatePickerClearButton';

export const IconedDateTimePicker = ({
  icon,
  hideBorderBottom = false,
  ...props
}: IconedDateTimePickerProps) => {
  const { onChange, value, defaultValue } = props;
  const classes = useStyles({ hideBorderBottom });

  return (
    <>
      <div className={classes.container}>
        <DateTimePickerIcon
          icon={icon}
        />
        <DateTimePicker
          {...props}
          classes={{
            datePicker: classes.datePicker
          }}
        />
        <DatePickerClearButton
          show={defaultValue !== value}
          onClick={() => {
            if (onChange && defaultValue) {
              onChange(defaultValue);
            }
          }}
        />
        <DateTimePickerArrowIcon />
      </div>
    </>
  )
};

export interface IconedDateTimePickerProps extends DateTimePickerProps {
  icon?: string;
  hideBorderBottom?: boolean;
}